import React, { createRef } from "react";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";
import {
  Select,
  Button,
  Space,
  Row,
  Col,
  Checkbox,
  DatePicker,
  Dropdown,
  Modal,
  Image,
  Input,
  Tooltip,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import VehicleStore from "../store/VehicleStore";
import dayjs from "dayjs";
import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import conf from "../config";

import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import FleetTempSummaryReportStore from "../store/FleetTempSummaryReportStore";
import PythonMessageAlert from "./PythonMessageAlert";
const { RangePicker } = DatePicker;
const { Option } = Select;
let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    if (val.title?.length > 24) {
      val.width = 250;
    } else if (val.title?.length > 15) {
      val.width = 200;
    } else if (val.title?.length > 12) {
      val.width = 150;
    } else if (val.title?.length > 8) {
      val.width = 125;
    } else {
      val.width = 110;
    }
  });

  return arr;
};
class FleetTempSummaryReport extends React.Component {
  constructor(props, context) {
    super(props);

    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.pythonMessageRef = createRef();
    this.fleetTempSummaryReportStore = new FleetTempSummaryReportStore();
    this.vehicleStore = new VehicleStore();

    this.ExportOption = [
      {
        label: (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            {" "}
            <Image
              style={{ height: "18px", width: "18px", borderRadius: "0px" }}
              src={Excel}
            ></Image>
            {context.translate("_EXPORT_AS_EXCEL_")}
          </div>
        ),
        key: "excel",
      },
      {
        label: (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            {" "}
            <Image
              style={{ height: "18px", width: "18px", borderRadius: "0px" }}
              src={PDF}
            ></Image>
            {context.translate("_EXPORT_AS_PDF_")}
          </div>
        ),
        key: "pdf",
      },
    ];

    this.state = {
      loading: false,
      pageSize: 50,
      pageNo: 1,
      offset: 0,
      limit: 50,
      loadData: 0,
      selectedVehicles: [],
      modalVisible: false,
      column: "",
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD 23:59:59"),

      selectAllVehicles: false,
      showMonthPopup: false,

      Notcompany: false,
      Notasset: false,
      pythonReportMessage: false,
      reportmessage: "",
      Notdate: false,
      selectedColumns: widthAdderFunc([
        {
          title: context.translate("_DEPOT_NAME_"),
          dataIndex: "depotName",
          key: "depotName",
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_SUPERVISOR_NAME_"),
          dataIndex: "supervisorName",
          key: "supervisorName",
          ellipsis: { showTitle: true },
        },

        {
          title: context.translate("_FLEET_REPORTS_VEHICLENO_"),
          dataIndex: "vehicleNo",
          key: "vehicleNo",
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_Kms_COVERED_"),
          dataIndex: "distance",
          key: "distance",
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_REMARK_"),
          dataIndex: "remark",
          key: "remark",
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_AVG_TEMP1_"),
          dataIndex: "avgTemp1",
          key: "avgTemp1",
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_AVG_TEMP2_"),
          dataIndex: "avgTemp2",
          key: "avgTemp2",
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_AVG_TEMP3_"),
          dataIndex: "avgTemp3",
          key: "avgTemp3",
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_AVG_TEMP4_"),
          dataIndex: "avgTemp4",
          key: "avgTemp4",
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_MAX_TEMP1_"),
          dataIndex: "maxTemp1",
          key: "maxTemp1",
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_MAX_TEMP2_"),
          dataIndex: "maxTemp2",
          key: "maxTemp2",
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_MAX_TEMP3_"),
          dataIndex: "maxTemp3",
          key: "maxTemp3",
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_MAX_TEMP4_"),
          dataIndex: "maxTemp4",
          key: "maxTemp4",
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_MIN_TEMP1_"),
          dataIndex: "minTemp1",
          key: "minTemp1",
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_MIN_TEMP2_"),
          dataIndex: "minTemp2",
          key: "minTemp2",
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_MIN_TEMP3_"),
          dataIndex: "minTemp3",
          key: "minTemp3",
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_MIN_TEMP4_"),
          dataIndex: "minTemp4",
          key: "minTemp4",
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_MIN_TEMP4_"),
          dataIndex: "minTemp4",
          key: "minTemp4",
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_DOOR_OPENING_DURATION_"),
          dataIndex: "doorOpeningDuration",
          key: "doorOpeningDuration",
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_DOOR_OPENING_COUNT_"),
          dataIndex: "doorCount",
          key: "doorCount",
          ellipsis: { showTitle: true },
        },
      ]),
    };

    this.menuProps = {
      items: this.ExportOption,
      onClick: async (val) => {
        let result = [];
        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));
          var getData = {
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,

            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
            colList: result.toString(),
          };
          if (val.key == "excel") {
            await this.fleetTempSummaryReportStore.exportExcel(getData);

            const isSuccess =
              this.fleetTempSummaryReportStore?.pythonReportMessage === true;
            const isError =
              this.fleetTempSummaryReportStore?.pythonReportErrorMessage;

            if (isSuccess || isError) {
              await this.setState({
                reportmessage: isSuccess ? "success" : "error",
              });
              await this.triggerReport();
            }
          }
          if (val.key == "pdf") {
            await this.fleetTempSummaryReportStore.exportpdf(getData);
            const isSuccess =
              this.fleetTempSummaryReportStore?.pythonReportMessage === true;
            const isError =
              this.fleetTempSummaryReportStore?.pythonReportErrorMessage;

            if (isSuccess || isError) {
              await this.setState({
                reportmessage: isSuccess ? "success" : "error",
              });
              await this.triggerReport();
            }
          }
        }
      },
    };
    this.newColumns = widthAdderFunc([...this.state.selectedColumns]);
  }

  triggerReport = () => {
    this.pythonMessageRef.current.show(); // show the modal
  };
  async componentDidMount() {
    this.setState({ pageSize: 50 });
    // await this.canBusReportStore.loadData({ offset: 0, limit: 50 });
    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }

    await this.setState({ column: this.state.selectedColumns });
  }

  async handleChange(comp) {
    await this.setState({ companyId: comp.value });
    await this.setState({ selectedVehicles: [], selectAllVehicles: false });
    await this.vehicleStore.getVehiclesCompanyId(comp.value);
    await this.handleSearch();
  }

  async handleSearch() {
    await this.setState({ loadData: 1 });
  }

  refreshList = async () => {
    await this.setState({ loading: false, pageNo: 1, currentPage: 1 });
    await this.showData();
  };
  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      pageNo: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.showData();
  }

  showData = async () => {
    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
    } else {
      this.setState({ Notcompany: false });
    }
    if (this.state.selectedVehicles.length === 0) {
      this.setState({ Notasset: true });
    } else {
      this.setState({ Notasset: false });
    }
    if (!this.state.fromDate) {
      this.setState({ Notdate: true });
    } else {
      this.setState({ Notdate: false });
    }
    if (this.checkFromDate(this.state.fromdateStdTime)) {
      if (
        this.state.companyId &&
        this.state.selectedVehicles.length > 0 &&
        this.state.fromDate &&
        this.state.toDate
      ) {
        this.setState({ Notcompany: false, Notasset: false });
        await this.fleetTempSummaryReportStore.loadData({
          offset: (this.state.pageNo - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: this.state.companyId,
          vehicleId: this.state.selectedVehicles,

          fromDate: this.state.fromDate,
          toDate: this.state.toDate,
          pageNo: this.state.pageNo,
        });
        await this.setState({ loadData: 1 });
      }
    }
  };

  handleAllSelectVehicles = async (e) => {
    if (this.state.selectAllVehicles) {
      const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId.map(
        (val) => {
          return val.vehicleId;
        }
      );
      await this.setState({ selectedVehicles: allVehicles });
    } else {
      await this.setState({ selectedVehicles: [] });
    }
  };

  handleCheckboxChange = async (column) => {
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );

      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };

  onDateTimeChange = (dates) => {
    if (dates) {
      const format = "YYYY-MM-DD HH:mm:ss";
      this.setState({
        fromdateStdTime: dates[0],
        fromDate: dates[0].format(format),
        toDate: dates[1].format(format),
      });
    } else {
      this.setState({ fromDate: "", toDate: "" });
    }
  };

  addMonths = (date, months) => {
    // date.setMonth(date.getMonth() + months);
    // date = date + months;
    var indx = dayjs().month() + -6;
    // return date.format("YYYY-MM-DD HH:mm:ss");
    return dayjs().month(indx);
  };
  checkFromDate(dates) {
    //  var fromDate = dates.format("YYYY-MM-DD HH:mm:ss");
    var fromDate = dates;
    var pdate = this.addMonths();
    if (pdate > fromDate) {
      //  Ext.Msg.show({
      //      title: fleet.Language.get('_FLEET_ALERT_'),
      //      msg: fleet.Language.get('_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_'),
      //      buttons: Ext.Msg.OK,
      //  });
      this.setState({ showMonthPopup: true });
      return false;
    } else {
      return true;
    }
  }

  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={20}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  allowClear={true}
                  onChange={this.handleChange}
                  style={{ width: 170 }}
                  status={this.state.Notcompany ? "error" : false}
                />

                {this.props.getUserData().isadmin === 1 && (
                  <DeviceGroupsForVehicles
                    vehicleStore={this.vehicleStore}
                    setLoadDta={() => this.setState({ loadData: 1 })}
                    resetVehicles={() =>
                      this.setState({
                        selectedVehicles: [],
                        selectAllVehicles: false,
                      })
                    }
                  />
                )}
                <Checkbox
                  checked={this.state.selectAllVehicles}
                  onChange={async (e) => {
                    await this.setState({
                      selectAllVehicles: e.target.checked,
                    });

                    await this.handleAllSelectVehicles();
                  }}
                />

                {this.context.translate("_ALL_")}

                <Select
                  className="searchInput"
                  maxTagCount="responsive"
                  value={this.state.selectedVehicles}
                  onChange={(val) => {
                    this.setState({ selectedVehicles: val });
                    if (
                      this.vehicleStore?.getVehiclesUsingCompanyId?.length >
                      val.length
                    ) {
                      this.setState({ selectAllVehicles: false });
                    } else {
                      this.setState({ selectAllVehicles: true });
                    }

                    if (val?.length > 1) {
                      this.setState({ showAlertPopup: true });
                    }
                  }}
                  style={{ width: 170 }}
                  showSearch
                  status={this.state.Notasset ? "error" : false}
                  mode="multiple"
                  placeholder={this.context.translate(
                    "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                  )}
                  filterOption={(inputValue, option) => {
                    if (option.children) {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(inputValue.toLowerCase()) >= 0
                      );
                    }
                  }}
                >
                  {this.vehicleStore?.getVehiclesUsingCompanyId?.map((val) => {
                    return (
                      <Option value={val.vehicleId}>{val.vehicleNo}</Option>
                    );
                  })}
                </Select>
                <RangePicker
                  status={this.state.Notdate ? "error" : false}
                  placeholder={[
                    this.context.translate("_FROM_DATE_TIME_"),
                    this.context.translate("_TO_DATETIME_"),
                  ]}
                  format="DD-MM-YYYY hh:mmA"
                  style={{ width: 400, borderRadius: "25px" }}
                  onChange={(val) => {
                    this.onDateTimeChange(val);
                  }}
                  // disabledDate={(current) => {
                  //   return current && current > dayjs();
                  // }}
                  showTime={{
                    format: "h:mmA",
                    defaultValue: [
                      dayjs().startOf("day"),
                      dayjs().endOf("day"),
                    ],
                  }}
                  defaultValue={[dayjs().startOf("day"), dayjs().endOf("day")]}
                />

                <Button type="primary" onClick={() => this.showData()}>
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>

                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>
              </Space>
            </Col>
            <Col span={4}>
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>
                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.fleetTempSummaryReportStore?.fleetTempSummary?.length >
                    0
                      ? false
                      : true
                  }
                >
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.menuProps}
                  >
                    <Image
                      style={{
                        height: 18,
                        alignItems: "center",
                        marginInlineEnd: "30px",
                      }}
                      src={downloadIcon}
                    ></Image>
                  </Dropdown>
                </Button>
              </Space>
            </Col>
          </Row>

          <Modal
            open={this.state.modalVisible}
            width={350}
            // title="Select Columns"
            title={this.context.translate("_SELECT_COLUMNS_")}
            onCancel={() => this.setState({ modalVisible: false })}
            onOk={() => {
              this.setState({ modalVisible: false });
            }}
            footer={null}
          >
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {this.newColumns.map((column, v) => {
                return (
                  <Row key={v}>
                    <Col>
                      <Checkbox
                        onChange={() => this.handleCheckboxChange(column)}
                        checked={this.state.selectedColumns.some(
                          (c) => c.key === column.key
                        )}
                      >
                        {column.title}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </Modal>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.fleetTempSummaryReportStore?.total}
            columns={this.state.column}
            dataSource={this.fleetTempSummaryReportStore?.fleetTempSummary}
            loading={this.fleetTempSummaryReportStore?.loading}
            onChange={this.handleTableChange}
            {...(conf.currentFlavor === "nodeui" && {
              showSizeChanger: false,
              moreClass: "gridNum",
            })}
          />
        </div>

        <Modal
          width={350}
          className="alert-model"
          title={
            <div>
              {" "}
              <i
                style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                class="bi bi-exclamation-triangle"
              ></i>{" "}
              {this.context.translate("_FLEET_ALERT_")}
            </div>
          }
          open={this.state.showMonthPopup}
          onOk={() => this.setState({ showMonthPopup: false })}
          onCancel={() => this.setState({ showMonthPopup: false })}
          footer={false}
        >
          {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
        </Modal>

        <PythonMessageAlert
          ref={this.pythonMessageRef}
          message={this.state.reportmessage}
        />
      </>
    );
  }
}
FleetTempSummaryReport.contextType = StoreContext;
export default observer(withRouter(FleetTempSummaryReport));
